<app-header></app-header>

<div class="page-title-area medici-bg ">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Acasa</a></li>
                <li>Echipa</li>
            </ul>
            <h2>Medici C.M.D.T.A.M.P</h2>
        </div>
    </div>
</div>

<div class="courses-details-area pt-50 pb-70">
    <div class="container">
        <div class="row">
            <div class="col courses-details-desc">
                <div class="courses-review-comments" *ngFor="let specialty of specialties">
                    <div *ngIf="specialty.doctors.length != 0">
                        <h3><i class='cmdtamp-{{specialty.logo_url}}'></i>
                            {{specialty.name}}</h3>
                        <div class="row">
                            <div class="col-lg-4 col-sm-6" *ngFor="let doctor of specialty.doctors">
                                <a class="user-review" href="/echipa/medic/{{doctor.friendlyUrl}}">
                                    <div *ngIf="doctor.photo"><img [src]="setFilePath(doctor)" alt="test"></div>
                                    <div *ngIf="!doctor.photo"><img src="../../../assets/img/medici/no-image.jpg"
                                                                    alt="image"></div>
                                    <div>
                                        <span class="d-block sub-comment">{{doctor.name}}</span>
                                        <p *ngIf="doctor.medicalStaffType == 'M'">Medic {{doctor.professionalDegree}}</p>
                                        <p *ngIf="doctor.medicalStaffType == 'L'">Biolog (Laborant Sef)</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
